<template>
   <div class="a-vs-b--no-connection-modal" >
		<img src="https://cloud.aleacontrol.com/media/vSoccer/no-connection-server.svg" alt="no-connection">
		<p v-html="$t('modal_connection_error')"></p>
   </div>
</template>
<script>
export default {
}
</script>
